const rootName = 'u-100-vh';
let inlineCss;
let vw = window.innerWidth;

function update() {
  inlineCss = document.querySelector(`.inline-${rootName}`);

  if (!inlineCss) {
    inlineCss = document.createElement('style');
    inlineCss.classList.add(`inline-${rootName}`);
    document.querySelector('head').appendChild(inlineCss);
  }

  inlineCss.textContent = `
    .u-100-vh {
      height: ${window.innerHeight}px;
    }
    .u-100-vh-min-height {
      min-height: ${window.innerHeight}px;
    }
  `;
}

function onWindowResize() {
  if (vw !== window.innerWidth) {
    update();
  }
}

update();

window.addEventListener('resize', () => {
  onWindowResize;
});

export default update;



// WEBPACK FOOTER //
// ./src/scripts/utils/u-100-vh.js